import { ClientLogger } from 'bernie-client';
import type { Controller, FetchOptions, FetchPageOptions } from 'bernie-core';
import { codeSplit } from 'bernie-core';
import type { PageData } from 'bernie-http';
import { Localization } from 'bernie-l10n';
import type { PageStore } from 'bernie-plugin-mobx';

import { MY_LIST_CUSTOMER_MIGRATION_CONTROLLER_INFO } from 'logging/log-events';
import { logDetailedEvent } from 'logging/logger';

export class MyListCustomerMigrationController implements Controller {
  public readonly bundles = [];
  public readonly component = codeSplit(
    /* istanbul ignore next */
    () => import(/* webpackChunkName: "my-list-customer-migration" */ 'views/my-list-customer-migration-view')
  );
  public readonly pageId = 'page.Trip.MyListCutomerMigration,U,80';
  public readonly path = '/lists';
  public readonly routeName = 'my-list-customer-migration';
  public readonly pageName = 'page.Trip.My.List.Customer.Migration';
  public readonly clickstreamPageName = 'Trip My List Customer Migration';
  public readonly exact = true;

  public fetch(options: FetchOptions): Promise<void> {
    const { stores } = options;

    stores.get<PageStore>('page').pageName = this.pageName;
    ClientLogger.setGlobalData('pageName', this.pageName);

    logDetailedEvent(options.logger, MY_LIST_CUSTOMER_MIGRATION_CONTROLLER_INFO, {
      request: options.request,
      message: 'Request made to my-lists-customer-migration-controller'
    });

    return Promise.resolve();
  }

  public fetchPageData(pageData: FetchPageOptions): Promise<PageData> {
    const localizer = new Localization(pageData.context.locale);
    const pageTitle = localizer.formatText('travelpulse.list.moved.page.title', pageData.context.site.name);

    return Promise.resolve({
      pageId: this.pageId,
      pageName: this.pageName,
      clickstreamPageName: this.clickstreamPageName,
      title: pageTitle
    });
  }
}
